const configuredBase = import.meta.env.VITE_API_BASE_URL?.trim();

export function isBackendConfigured(): boolean {
  return Boolean(configuredBase);
}

export async function apiRequest<T>(path: string, init?: RequestInit): Promise<T> {
  if (!configuredBase) throw new Error('Cloud services are not configured.');
  const response = await fetch(`${configuredBase}${path}`, {
    ...init,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...init?.headers },
  });
  const body = await response.json().catch(() => ({})) as T & { error?: string };
  if (!response.ok) throw new Error(body.error ?? `Request failed (${response.status})`);
  return body;
}

export function apiUrl(path: string): string {
  if (!configuredBase) throw new Error('Cloud services are not configured.');
  return `${configuredBase}${path}`;
}
